function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
}

function initializeBackToTopButton() {
    document.addEventListener('DOMContentLoaded', function () {
        const backButton = document.getElementById('return-to-top');

        function toggleBackToTopButton() {
            if (window.scrollY > 0) {
                backButton.style.display = 'block';
            } else {
                backButton.style.display = 'none';
            }
        }

        if (backButton) {
            toggleBackToTopButton();

            backButton.addEventListener('click', function () {
                scrollToTop();
            });

            window.addEventListener('scroll', toggleBackToTopButton);
        }
    });
}

scrollToTop();
initializeBackToTopButton();
